module.exports = __webpack_public_path__ + "static/img/1.74a3699.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/1.png
// module id = iI87
// module chunks = 0